webpackJsonp([0],{

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(537),
  /* template */
  __webpack_require__(670),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 537:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function mounted() {
	this.localZoom = this.zoom;
	this.currentPlace = this.location;
	this.geolocate();
	if (this.allMarkers.length > 0) {
		this.setAllMarkers();
	}
}

function geolocate() {
	this.markers.push({ position: this.location });
}

function setAllMarkers() {
	var _this = this;

	var onlyLat = [];
	var onlyLng = [];
	this.allMarkers.forEach(function (m) {
		if (m.location) {
			var id = m.id,
			    name = m.name;
			var _m$location = m.location,
			    lat = _m$location.x,
			    lng = _m$location.y;

			_this.markers.push({ position: { lat: lat, lng: lng, id: id, name: name } });
			onlyLat.push(lat);
			onlyLng.push(lng);
		}
	});
	var averageLat = onlyLat.reduce(function (acc, it) {
		return acc + it;
	}, 0) / onlyLat.length;
	var averageLng = onlyLng.reduce(function (acc, it) {
		return acc + it;
	}, 0) / onlyLng.length;
	this.currentPlace = { lat: averageLat, lng: averageLng };
}

function selectedMarker(selectedMarked) {
	this.$emit('choosed-warehouse', selectedMarked.position);
}

function zoom(newZoom) {
	this.localZoom = newZoom;
}

function locationHandler(newLocation) {
	this.currentPlace = newLocation;
}

function markersHandler(newMarkers) {
	this.markers = newMarkers;
}

function data() {
	return {
		localZoom: this.zoom,
		markers: [],
		places: []
	};
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'google-map',
	data: data,
	methods: {
		geolocate: geolocate,
		locationHandler: locationHandler,
		markersHandler: markersHandler,
		selectedMarker: selectedMarker,
		setAllMarkers: setAllMarkers
	},
	mounted: mounted,
	props: {
		location: {
			default: function _default() {},
			type: Object
		},
		allMarkers: {
			default: function _default() {
				return [];
			},
			type: Array
		},
		zoom: {
			default: 15,
			type: Number
		}
	},
	watch: {
		location: {
			deep: true,
			handler: locationHandler
		},
		markers: {
			deep: true,
			handler: markersHandler
		},
		zoom: zoom
	}
});

/***/ }),

/***/ 670:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "center": _vm.currentPlace,
      "zoom": _vm.localZoom
    },
    on: {
      "center_changer": function($event) {
        _vm.$emit('on-center-changed', $event)
      }
    }
  }, _vm._l((_vm.markers), function(m, index) {
    return _c('gmap-marker', {
      key: index,
      attrs: {
        "clickable": true,
        "position": m.position
      },
      on: {
        "click": function($event) {
          _vm.selectedMarker(m)
        }
      }
    })
  }))], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/0.f70d57c22f6526279a7f.js